import React from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import Select from 'react-select';
import { FaSearch, FaEraser } from 'react-icons/fa';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

// W-0804 — Filtros do relatório de acordos não concretizados.
// Período (data inicial/final de inativação) é obrigatório (RN-02): "Gerar" desabilitado até
// as duas datas estarem preenchidas. Cobrador/Empreendimento são opcionais.
const TIPOS_TITULO = [
  { value: 0, label: 'Normal' },
  { value: 1, label: 'Int.Vendas' },
  { value: 2, label: 'Todos' },
];

const OPCOES = [
  { value: true, label: 'Analítico' },
  { value: false, label: 'Sintético' },
];

const FOCOS = [
  { value: 0, label: 'Cobradores' },
  { value: 1, label: 'Empreendimento' },
];

const FiltrosAcordosNaoConcretizados = ({
  filtros,
  onChange,
  cobradores,
  empreendimentos,
  carregando,
  onBuscar,
  onLimpar,
}) => {
  const set = (campo, valor) => onChange({ ...filtros, [campo]: valor });

  const optionsCobrador = (cobradores || []).map((c) => ({
    value: c.codigo_conta,
    label: c.nome_prestador || String(c.codigo_conta),
  }));
  const optionsEmpreendimento = (empreendimentos || []).map((e) => ({
    value: e.codigo_familia,
    label: e.descricao,
  }));

  const valCobrador =
    optionsCobrador.find((o) => o.value === filtros.cobrador) || null;
  const valEmpreendimento =
    optionsEmpreendimento.find((o) => o.value === filtros.empreendimento) || null;

  const periodoPreenchido = !!filtros.data_inicial && !!filtros.data_final;

  const handleSubmit = (e) => {
    e.preventDefault();
    onBuscar();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col xs="12" md="3">
          <Form.Group controlId="acordos.dataInicial">
            <Form.Label>Data Inicial (inativação) *</Form.Label>
            <Form.Control
              type="date"
              value={filtros.data_inicial || ''}
              onChange={(e) => set('data_inicial', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col xs="12" md="3">
          <Form.Group controlId="acordos.dataFinal">
            <Form.Label>Data Final (inativação) *</Form.Label>
            <Form.Control
              type="date"
              value={filtros.data_final || ''}
              onChange={(e) => set('data_final', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col xs="12" md="3">
          <Form.Group controlId="acordos.cobrador">
            <Form.Label>Cobrador</Form.Label>
            <Select
              placeholder="Todos"
              options={optionsCobrador}
              value={valCobrador}
              onChange={(opt) => set('cobrador', opt ? opt.value : null)}
              isClearable
              styles={customStyles}
              components={{ DropdownIndicator }}
              noOptionsMessage={() => 'Nenhum cobrador'}
            />
          </Form.Group>
        </Col>
        <Col xs="12" md="3">
          <Form.Group controlId="acordos.empreendimento">
            <Form.Label>Empreendimento</Form.Label>
            <Select
              placeholder="Todos"
              options={optionsEmpreendimento}
              value={valEmpreendimento}
              onChange={(opt) => set('empreendimento', opt ? opt.value : null)}
              isClearable
              styles={customStyles}
              components={{ DropdownIndicator }}
              noOptionsMessage={() => 'Nenhum empreendimento'}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs="12" md="4">
          <Form.Group>
            <Form.Label>Considerar Títulos</Form.Label>
            <div className="d-flex" style={{ gap: 16 }}>
              {TIPOS_TITULO.map((t) => (
                <Form.Check
                  key={`tipo-${t.value}`}
                  type="radio"
                  name="acordosTipoTitulo"
                  id={`tipo-${t.value}`}
                  label={t.label}
                  checked={filtros.tipo_titulo === t.value}
                  onChange={() => set('tipo_titulo', t.value)}
                  inline
                />
              ))}
            </div>
          </Form.Group>
        </Col>
        <Col xs="12" md="4">
          <Form.Group>
            <Form.Label>Opção</Form.Label>
            <div className="d-flex" style={{ gap: 16 }}>
              {OPCOES.map((o) => (
                <Form.Check
                  key={`op-${String(o.value)}`}
                  type="radio"
                  name="acordosOpcao"
                  id={`op-${String(o.value)}`}
                  label={o.label}
                  checked={filtros.analitico === o.value}
                  onChange={() => set('analitico', o.value)}
                  inline
                />
              ))}
            </div>
          </Form.Group>
        </Col>
        <Col xs="12" md="4">
          <Form.Group>
            <Form.Label>Foco</Form.Label>
            <div className="d-flex" style={{ gap: 16 }}>
              {FOCOS.map((f) => (
                <Form.Check
                  key={`foco-${f.value}`}
                  type="radio"
                  name="acordosFoco"
                  id={`foco-${f.value}`}
                  label={f.label}
                  checked={filtros.foco === f.value}
                  onChange={() => set('foco', f.value)}
                  inline
                />
              ))}
            </div>
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end" style={{ gap: 8 }}>
        <Button type="button" variant="outline-secondary" onClick={onLimpar} disabled={carregando}>
          <FaEraser />
          <span>&nbsp;Limpar</span>
        </Button>
        <Button type="submit" variant="primary" disabled={carregando || !periodoPreenchido}>
          <FaSearch />
          <span>&nbsp;Gerar</span>
        </Button>
      </div>
    </Form>
  );
};

export default FiltrosAcordosNaoConcretizados;
